// importa o axios para fazer as requisições para o back
import axios from 'axios'
import router from '@/router'

const url = process.env.VUE_APP_API_BASE_URL

const Request = async ({route, method = 'GET', body = null}) => {
    
    var token = await localStorage.getItem('token')
    var resp = null

    var params = await {
        url: url + route,
        method: method,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
    }

    if (method != 'GET'){
        params.data = await body
    }
    axios.defaults.headers.common['ngrok-skip-browser-warning'] = true;
    if(token != ''){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    }else{
        await delete axios.defaults.headers.common['Authorization']
    }
    
    try{
        resp = await axios(params)
    }catch(e){
        resp = e.response
    }

    if(resp.status == 401){
        await router.push('logout')
    }
    return resp 
}

export default Request